import { Component, EventEmitter, inject, Output } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { CommonModalFormComponent } from '@shared/components/commons/common-modal-form/common-modal-form.component';
import { InputComponent } from '@shared/controls/input/input.component';
import { CustomFormValidators } from '@shared/validators/custom-form-validators';

@Component({
  selector: 'app-mark-as-lodged',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    CommonModalFormComponent,
    InputComponent,
  ],
  templateUrl: 'mark-as-lodged.component.html',
})
export class MarkAsLodgedComponent {
  activeModal = inject(NgbActiveModal);

  @Output() confirm = new EventEmitter<string>();

  readonly customErrors = {
    required: 'Document number is required.',
    maxLength: 'Your input must be 9 characters',
    minLength: 'Your input must be 9 characters'
  };

  asicNumberControl = new FormControl<string | null>('', [Validators.required, CustomFormValidators.onlyLettersAndNumbersAllowedValidator, CustomFormValidators.minLength(9), CustomFormValidators.maxLength(9)]);

  close(): void {
    this.activeModal.close();
  }

  save() {
    if (this.asicNumberControl.invalid) {
      this.asicNumberControl.markAllAsTouched();
      return;
    }

    this.confirm.emit(this.asicNumberControl.value!);
    this.activeModal.close();
  }
}
